export default __webpack_public_path__ + "static/media/config.07edaac6.svg";